export const pokemonsBase = [
    {
        "pokedex_id": 10,
        "name": "Caterpie",
        "capture_rate": 255
    },
    {
        "pokedex_id": 13,
        "name": "Weedle",
        "capture_rate": 255
    },
    {
        "pokedex_id": 16,
        "name": "Pidgey",
        "capture_rate": 255
    },
    {
        "pokedex_id": 19,
        "name": "Rattata",
        "capture_rate": 255
    },
    {
        "pokedex_id": 21,
        "name": "Spearow",
        "capture_rate": 255
    },
    {
        "pokedex_id": 23,
        "name": "Ekans",
        "capture_rate": 255
    },
    {
        "pokedex_id": 25,
        "name": "PikachuPartner",
        "capture_rate": 255
    },
    {
        "pokedex_id": 27,
        "name": "Sandshrew",
        "capture_rate": 255
    },
    {
        "pokedex_id": 41,
        "name": "Zubat",
        "capture_rate": 255
    },
    {
        "pokedex_id": 43,
        "name": "Oddish",
        "capture_rate": 255
    },
    {
        "pokedex_id": 50,
        "name": "Diglett",
        "capture_rate": 255
    },
    {
        "pokedex_id": 52,
        "name": "Meowth",
        "capture_rate": 255
    },
    {
        "pokedex_id": 60,
        "name": "Poliwag",
        "capture_rate": 255
    },
    {
        "pokedex_id": 69,
        "name": "Bellsprout",
        "capture_rate": 255
    },
    {
        "pokedex_id": 74,
        "name": "Geodude",
        "capture_rate": 255
    },
    {
        "pokedex_id": 129,
        "name": "Magikarp",
        "capture_rate": 255
    },
    {
        "pokedex_id": 133,
        "name": "EeveePartner",
        "capture_rate": 255
    },
    {
        "pokedex_id": 161,
        "name": "Sentret",
        "capture_rate": 255
    },
    {
        "pokedex_id": 163,
        "name": "Hoothoot",
        "capture_rate": 255
    },
    {
        "pokedex_id": 165,
        "name": "Ledyba",
        "capture_rate": 255
    },
    {
        "pokedex_id": 167,
        "name": "Spinarak",
        "capture_rate": 255
    },
    {
        "pokedex_id": 187,
        "name": "Hoppip",
        "capture_rate": 255
    },
    {
        "pokedex_id": 194,
        "name": "Wooper",
        "capture_rate": 255
    },
    {
        "pokedex_id": 261,
        "name": "Poochyena",
        "capture_rate": 255
    },
    {
        "pokedex_id": 263,
        "name": "Zigzagoon",
        "capture_rate": 255
    },
    {
        "pokedex_id": 265,
        "name": "Wurmple",
        "capture_rate": 255
    },
    {
        "pokedex_id": 270,
        "name": "Lotad",
        "capture_rate": 255
    },
    {
        "pokedex_id": 273,
        "name": "Seedot",
        "capture_rate": 255
    },
    {
        "pokedex_id": 285,
        "name": "Shroomish",
        "capture_rate": 255
    },
    {
        "pokedex_id": 287,
        "name": "Slakoth",
        "capture_rate": 255
    },
    {
        "pokedex_id": 290,
        "name": "Nincada",
        "capture_rate": 255
    },
    {
        "pokedex_id": 299,
        "name": "Nosepass",
        "capture_rate": 255
    },
    {
        "pokedex_id": 300,
        "name": "Skitty",
        "capture_rate": 255
    },
    {
        "pokedex_id": 322,
        "name": "Numel",
        "capture_rate": 255
    },
    {
        "pokedex_id": 325,
        "name": "Spoink",
        "capture_rate": 255
    },
    {
        "pokedex_id": 327,
        "name": "Spinda",
        "capture_rate": 255
    },
    {
        "pokedex_id": 328,
        "name": "Trapinch",
        "capture_rate": 255
    },
    {
        "pokedex_id": 333,
        "name": "Swablu",
        "capture_rate": 255
    },
    {
        "pokedex_id": 343,
        "name": "Baltoy",
        "capture_rate": 255
    },
    {
        "pokedex_id": 349,
        "name": "Feebas",
        "capture_rate": 255
    },
    {
        "pokedex_id": 363,
        "name": "Spheal",
        "capture_rate": 255
    },
    {
        "pokedex_id": 366,
        "name": "Clamperl",
        "capture_rate": 255
    },
    {
        "pokedex_id": 396,
        "name": "Starly",
        "capture_rate": 255
    },
    {
        "pokedex_id": 399,
        "name": "Bidoof",
        "capture_rate": 255
    },
    {
        "pokedex_id": 401,
        "name": "Kricketot",
        "capture_rate": 255
    },
    {
        "pokedex_id": 406,
        "name": "Budew",
        "capture_rate": 255
    },
    {
        "pokedex_id": 436,
        "name": "Bronzor",
        "capture_rate": 255
    },
    {
        "pokedex_id": 438,
        "name": "Bonsly",
        "capture_rate": 255
    },
    {
        "pokedex_id": 504,
        "name": "Patrat",
        "capture_rate": 255
    },
    {
        "pokedex_id": 505,
        "name": "Watchog",
        "capture_rate": 255
    },
    {
        "pokedex_id": 506,
        "name": "Lillipup",
        "capture_rate": 255
    },
    {
        "pokedex_id": 509,
        "name": "Purrloin",
        "capture_rate": 255
    },
    {
        "pokedex_id": 519,
        "name": "Pidove",
        "capture_rate": 255
    },
    {
        "pokedex_id": 524,
        "name": "Roggenrola",
        "capture_rate": 255
    },
    {
        "pokedex_id": 531,
        "name": "Audino",
        "capture_rate": 255
    },
    {
        "pokedex_id": 535,
        "name": "Tympole",
        "capture_rate": 255
    },
    {
        "pokedex_id": 540,
        "name": "Sewaddle",
        "capture_rate": 255
    },
    {
        "pokedex_id": 543,
        "name": "Venipede",
        "capture_rate": 255
    },
    {
        "pokedex_id": 556,
        "name": "Maractus",
        "capture_rate": 255
    },
    {
        "pokedex_id": 572,
        "name": "Minccino",
        "capture_rate": 255
    },
    {
        "pokedex_id": 582,
        "name": "Vanillite",
        "capture_rate": 255
    },
    {
        "pokedex_id": 597,
        "name": "Ferroseed",
        "capture_rate": 255
    },
    {
        "pokedex_id": 605,
        "name": "Elgyem",
        "capture_rate": 255
    },
    {
        "pokedex_id": 659,
        "name": "Bunnelby",
        "capture_rate": 255
    },
    {
        "pokedex_id": 661,
        "name": "Fletchling",
        "capture_rate": 255
    },
    {
        "pokedex_id": 664,
        "name": "Scatterbug",
        "capture_rate": 255
    },
    {
        "pokedex_id": 731,
        "name": "Pikipek",
        "capture_rate": 255
    },
    {
        "pokedex_id": 734,
        "name": "Yungoos",
        "capture_rate": 255
    },
    {
        "pokedex_id": 736,
        "name": "Grubbin",
        "capture_rate": 255
    },
    {
        "pokedex_id": 800,
        "name": "Necrozma",
        "capture_rate": 255
    },
    {
        "pokedex_id": 819,
        "name": "Skwovet",
        "capture_rate": 255
    },
    {
        "pokedex_id": 821,
        "name": "Rookidee",
        "capture_rate": 255
    },
    {
        "pokedex_id": 824,
        "name": "Blipbug",
        "capture_rate": 255
    },
    {
        "pokedex_id": 827,
        "name": "Nickit",
        "capture_rate": 255
    },
    {
        "pokedex_id": 831,
        "name": "Wooloo",
        "capture_rate": 255
    },
    {
        "pokedex_id": 833,
        "name": "Chewtle",
        "capture_rate": 255
    },
    {
        "pokedex_id": 835,
        "name": "Yamper",
        "capture_rate": 255
    },
    {
        "pokedex_id": 837,
        "name": "Rolycoly",
        "capture_rate": 255
    },
    {
        "pokedex_id": 840,
        "name": "Applin",
        "capture_rate": 255
    },
    {
        "pokedex_id": 843,
        "name": "Silicobra",
        "capture_rate": 255
    },
    {
        "pokedex_id": 846,
        "name": "Arrokuda",
        "capture_rate": 255
    },
    {
        "pokedex_id": 859,
        "name": "Impidimp",
        "capture_rate": 255
    },
    {
        "pokedex_id": 29,
        "name": "Nidoran♀",
        "capture_rate": 235
    },
    {
        "pokedex_id": 32,
        "name": "Nidoran♂",
        "capture_rate": 235
    },
    {
        "pokedex_id": 179,
        "name": "Mareep",
        "capture_rate": 235
    },
    {
        "pokedex_id": 191,
        "name": "Sunkern",
        "capture_rate": 235
    },
    {
        "pokedex_id": 280,
        "name": "Ralts",
        "capture_rate": 235
    },
    {
        "pokedex_id": 403,
        "name": "Shinx",
        "capture_rate": 235
    },
    {
        "pokedex_id": 761,
        "name": "Bounsweet",
        "capture_rate": 235
    },
    {
        "pokedex_id": 856,
        "name": "Hatenna",
        "capture_rate": 235
    },
    {
        "pokedex_id": 98,
        "name": "Krabby",
        "capture_rate": 225
    },
    {
        "pokedex_id": 116,
        "name": "Horsea",
        "capture_rate": 225
    },
    {
        "pokedex_id": 118,
        "name": "Goldeen",
        "capture_rate": 225
    },
    {
        "pokedex_id": 120,
        "name": "Staryu",
        "capture_rate": 225
    },
    {
        "pokedex_id": 201,
        "name": "Unown",
        "capture_rate": 225
    },
    {
        "pokedex_id": 220,
        "name": "Swinub",
        "capture_rate": 225
    },
    {
        "pokedex_id": 316,
        "name": "Gulpin",
        "capture_rate": 225
    },
    {
        "pokedex_id": 318,
        "name": "Carvanha",
        "capture_rate": 225
    },
    {
        "pokedex_id": 353,
        "name": "Shuppet",
        "capture_rate": 225
    },
    {
        "pokedex_id": 370,
        "name": "Luvdisc",
        "capture_rate": 225
    },
    {
        "pokedex_id": 434,
        "name": "Stunky",
        "capture_rate": 225
    },
    {
        "pokedex_id": 669,
        "name": "Flabébé",
        "capture_rate": 225
    },
    {
        "pokedex_id": 690,
        "name": "Skrelp",
        "capture_rate": 225
    },
    {
        "pokedex_id": 692,
        "name": "Clauncher",
        "capture_rate": 225
    },
    {
        "pokedex_id": 739,
        "name": "Crabrawler",
        "capture_rate": 225
    },
    {
        "pokedex_id": 667,
        "name": "Litleo",
        "capture_rate": 220
    },
    {
        "pokedex_id": 674,
        "name": "Pancham",
        "capture_rate": 220
    },
    {
        "pokedex_id": 341,
        "name": "Corphish",
        "capture_rate": 205
    },
    {
        "pokedex_id": 63,
        "name": "Abra",
        "capture_rate": 200
    },
    {
        "pokedex_id": 276,
        "name": "Taillow",
        "capture_rate": 200
    },
    {
        "pokedex_id": 283,
        "name": "Surskit",
        "capture_rate": 200
    },
    {
        "pokedex_id": 297,
        "name": "Hariyama",
        "capture_rate": 200
    },
    {
        "pokedex_id": 311,
        "name": "Plusle",
        "capture_rate": 200
    },
    {
        "pokedex_id": 312,
        "name": "Minun",
        "capture_rate": 200
    },
    {
        "pokedex_id": 352,
        "name": "Kecleon",
        "capture_rate": 200
    },
    {
        "pokedex_id": 357,
        "name": "Tropius",
        "capture_rate": 200
    },
    {
        "pokedex_id": 417,
        "name": "Pachirisu",
        "capture_rate": 200
    },
    {
        "pokedex_id": 455,
        "name": "Carnivine",
        "capture_rate": 200
    },
    {
        "pokedex_id": 574,
        "name": "Gothita",
        "capture_rate": 200
    },
    {
        "pokedex_id": 577,
        "name": "Solosis",
        "capture_rate": 200
    },
    {
        "pokedex_id": 587,
        "name": "Emolga",
        "capture_rate": 200
    },
    {
        "pokedex_id": 588,
        "name": "Karrablast",
        "capture_rate": 200
    },
    {
        "pokedex_id": 616,
        "name": "Shelmet",
        "capture_rate": 200
    },
    {
        "pokedex_id": 672,
        "name": "Skiddo",
        "capture_rate": 200
    },
    {
        "pokedex_id": 682,
        "name": "Spritzee",
        "capture_rate": 200
    },
    {
        "pokedex_id": 684,
        "name": "Swirlix",
        "capture_rate": 200
    },
    {
        "pokedex_id": 751,
        "name": "Dewpider",
        "capture_rate": 200
    },
    {
        "pokedex_id": 868,
        "name": "Milcery",
        "capture_rate": 200
    },
    {
        "pokedex_id": 25,
        "name": "Pikachu",
        "capture_rate": 190
    },
    {
        "pokedex_id": 37,
        "name": "Vulpix",
        "capture_rate": 190
    },
    {
        "pokedex_id": 46,
        "name": "Paras",
        "capture_rate": 190
    },
    {
        "pokedex_id": 48,
        "name": "Venonat",
        "capture_rate": 190
    },
    {
        "pokedex_id": 54,
        "name": "Psyduck",
        "capture_rate": 190
    },
    {
        "pokedex_id": 56,
        "name": "Mankey",
        "capture_rate": 190
    },
    {
        "pokedex_id": 58,
        "name": "Growlithe",
        "capture_rate": 190
    },
    {
        "pokedex_id": 72,
        "name": "Tentacool",
        "capture_rate": 190
    },
    {
        "pokedex_id": 77,
        "name": "Ponyta",
        "capture_rate": 190
    },
    {
        "pokedex_id": 79,
        "name": "Slowpoke",
        "capture_rate": 190
    },
    {
        "pokedex_id": 81,
        "name": "Magnemite",
        "capture_rate": 190
    },
    {
        "pokedex_id": 84,
        "name": "Doduo",
        "capture_rate": 190
    },
    {
        "pokedex_id": 86,
        "name": "Seel",
        "capture_rate": 190
    },
    {
        "pokedex_id": 88,
        "name": "Grimer",
        "capture_rate": 190
    },
    {
        "pokedex_id": 90,
        "name": "Shellder",
        "capture_rate": 190
    },
    {
        "pokedex_id": 92,
        "name": "Gastly",
        "capture_rate": 190
    },
    {
        "pokedex_id": 96,
        "name": "Drowzee",
        "capture_rate": 190
    },
    {
        "pokedex_id": 100,
        "name": "Voltorb",
        "capture_rate": 190
    },
    {
        "pokedex_id": 104,
        "name": "Cubone",
        "capture_rate": 190
    },
    {
        "pokedex_id": 109,
        "name": "Koffing",
        "capture_rate": 190
    },
    {
        "pokedex_id": 170,
        "name": "Chinchou",
        "capture_rate": 190
    },
    {
        "pokedex_id": 172,
        "name": "Pichu",
        "capture_rate": 190
    },
    {
        "pokedex_id": 175,
        "name": "Togepi",
        "capture_rate": 190
    },
    {
        "pokedex_id": 177,
        "name": "Natu",
        "capture_rate": 190
    },
    {
        "pokedex_id": 183,
        "name": "Marill",
        "capture_rate": 190
    },
    {
        "pokedex_id": 204,
        "name": "Pineco",
        "capture_rate": 190
    },
    {
        "pokedex_id": 206,
        "name": "Dunsparce",
        "capture_rate": 190
    },
    {
        "pokedex_id": 209,
        "name": "Snubbull",
        "capture_rate": 190
    },
    {
        "pokedex_id": 213,
        "name": "Shuckle",
        "capture_rate": 190
    },
    {
        "pokedex_id": 218,
        "name": "Slugma",
        "capture_rate": 190
    },
    {
        "pokedex_id": 223,
        "name": "Remoraid",
        "capture_rate": 190
    },
    {
        "pokedex_id": 278,
        "name": "Wingull",
        "capture_rate": 190
    },
    {
        "pokedex_id": 293,
        "name": "Whismur",
        "capture_rate": 190
    },
    {
        "pokedex_id": 331,
        "name": "Cacnea",
        "capture_rate": 190
    },
    {
        "pokedex_id": 339,
        "name": "Barboach",
        "capture_rate": 190
    },
    {
        "pokedex_id": 355,
        "name": "Duskull",
        "capture_rate": 190
    },
    {
        "pokedex_id": 361,
        "name": "Snorunt",
        "capture_rate": 190
    },
    {
        "pokedex_id": 418,
        "name": "Buizel",
        "capture_rate": 190
    },
    {
        "pokedex_id": 420,
        "name": "Cherubi",
        "capture_rate": 190
    },
    {
        "pokedex_id": 422,
        "name": "Shellos",
        "capture_rate": 190
    },
    {
        "pokedex_id": 427,
        "name": "Buneary",
        "capture_rate": 190
    },
    {
        "pokedex_id": 431,
        "name": "Glameow",
        "capture_rate": 190
    },
    {
        "pokedex_id": 456,
        "name": "Finneon",
        "capture_rate": 190
    },
    {
        "pokedex_id": 511,
        "name": "Pansage",
        "capture_rate": 190
    },
    {
        "pokedex_id": 513,
        "name": "Pansear",
        "capture_rate": 190
    },
    {
        "pokedex_id": 515,
        "name": "Panpour",
        "capture_rate": 190
    },
    {
        "pokedex_id": 517,
        "name": "Munna",
        "capture_rate": 190
    },
    {
        "pokedex_id": 522,
        "name": "Blitzle",
        "capture_rate": 190
    },
    {
        "pokedex_id": 527,
        "name": "Woobat",
        "capture_rate": 190
    },
    {
        "pokedex_id": 546,
        "name": "Cottonee",
        "capture_rate": 190
    },
    {
        "pokedex_id": 548,
        "name": "Petilil",
        "capture_rate": 190
    },
    {
        "pokedex_id": 557,
        "name": "Dwebble",
        "capture_rate": 190
    },
    {
        "pokedex_id": 562,
        "name": "Yamask",
        "capture_rate": 190
    },
    {
        "pokedex_id": 568,
        "name": "Trubbish",
        "capture_rate": 190
    },
    {
        "pokedex_id": 580,
        "name": "Ducklett",
        "capture_rate": 190
    },
    {
        "pokedex_id": 585,
        "name": "Deerling",
        "capture_rate": 190
    },
    {
        "pokedex_id": 590,
        "name": "Foongus",
        "capture_rate": 190
    },
    {
        "pokedex_id": 592,
        "name": "Frillish",
        "capture_rate": 190
    },
    {
        "pokedex_id": 595,
        "name": "Joltik",
        "capture_rate": 190
    },
    {
        "pokedex_id": 602,
        "name": "Tynamo",
        "capture_rate": 190
    },
    {
        "pokedex_id": 607,
        "name": "Litwick",
        "capture_rate": 190
    },
    {
        "pokedex_id": 622,
        "name": "Golett",
        "capture_rate": 190
    },
    {
        "pokedex_id": 627,
        "name": "Rufflet",
        "capture_rate": 190
    },
    {
        "pokedex_id": 629,
        "name": "Vullaby",
        "capture_rate": 190
    },
    {
        "pokedex_id": 677,
        "name": "Espurr",
        "capture_rate": 190
    },
    {
        "pokedex_id": 686,
        "name": "Inkay",
        "capture_rate": 190
    },
    {
        "pokedex_id": 694,
        "name": "Helioptile",
        "capture_rate": 190
    },
    {
        "pokedex_id": 712,
        "name": "Bergmite",
        "capture_rate": 190
    },
    {
        "pokedex_id": 714,
        "name": "Noibat",
        "capture_rate": 190
    },
    {
        "pokedex_id": 742,
        "name": "Cutiefly",
        "capture_rate": 190
    },
    {
        "pokedex_id": 744,
        "name": "Rockruff",
        "capture_rate": 190
    },
    {
        "pokedex_id": 747,
        "name": "Mareanie",
        "capture_rate": 190
    },
    {
        "pokedex_id": 749,
        "name": "Mudbray",
        "capture_rate": 190
    },
    {
        "pokedex_id": 753,
        "name": "Fomantis",
        "capture_rate": 190
    },
    {
        "pokedex_id": 755,
        "name": "Morelull",
        "capture_rate": 190
    },
    {
        "pokedex_id": 829,
        "name": "Gossifleur",
        "capture_rate": 190
    },
    {
        "pokedex_id": 850,
        "name": "Sizzlipede",
        "capture_rate": 190
    },
    {
        "pokedex_id": 872,
        "name": "Snom",
        "capture_rate": 190
    },
    {
        "pokedex_id": 878,
        "name": "Cufant",
        "capture_rate": 190
    },
    {
        "pokedex_id": 66,
        "name": "Machop",
        "capture_rate": 180
    },
    {
        "pokedex_id": 296,
        "name": "Makuhita",
        "capture_rate": 180
    },
    {
        "pokedex_id": 304,
        "name": "Aron",
        "capture_rate": 180
    },
    {
        "pokedex_id": 307,
        "name": "Meditite",
        "capture_rate": 180
    },
    {
        "pokedex_id": 532,
        "name": "Timburr",
        "capture_rate": 180
    },
    {
        "pokedex_id": 551,
        "name": "Sandile",
        "capture_rate": 180
    },
    {
        "pokedex_id": 559,
        "name": "Scraggy",
        "capture_rate": 180
    },
    {
        "pokedex_id": 619,
        "name": "Mienfoo",
        "capture_rate": 180
    },
    {
        "pokedex_id": 679,
        "name": "Honedge",
        "capture_rate": 180
    },
    {
        "pokedex_id": 702,
        "name": "Dedenne",
        "capture_rate": 180
    },
    {
        "pokedex_id": 777,
        "name": "Togedemaru",
        "capture_rate": 180
    },
    {
        "pokedex_id": 852,
        "name": "Clobbopus",
        "capture_rate": 180
    },
    {
        "pokedex_id": 877,
        "name": "Morpeko",
        "capture_rate": 180
    },
    {
        "pokedex_id": 39,
        "name": "Jigglypuff",
        "capture_rate": 170
    },
    {
        "pokedex_id": 174,
        "name": "Igglybuff",
        "capture_rate": 170
    },
    {
        "pokedex_id": 676,
        "name": "Furfrou",
        "capture_rate": 160
    },
    {
        "pokedex_id": 342,
        "name": "Crawdaunt",
        "capture_rate": 155
    },
    {
        "pokedex_id": 35,
        "name": "Clefairy",
        "capture_rate": 150
    },
    {
        "pokedex_id": 173,
        "name": "Cleffa",
        "capture_rate": 150
    },
    {
        "pokedex_id": 298,
        "name": "Azurill",
        "capture_rate": 150
    },
    {
        "pokedex_id": 313,
        "name": "Volbeat",
        "capture_rate": 150
    },
    {
        "pokedex_id": 314,
        "name": "Illumise",
        "capture_rate": 150
    },
    {
        "pokedex_id": 315,
        "name": "Roselia",
        "capture_rate": 150
    },
    {
        "pokedex_id": 323,
        "name": "Camerupt",
        "capture_rate": 150
    },
    {
        "pokedex_id": 439,
        "name": "Mime Jr.",
        "capture_rate": 145
    },
    {
        "pokedex_id": 449,
        "name": "Hippopotas",
        "capture_rate": 140
    },
    {
        "pokedex_id": 453,
        "name": "Croagunk",
        "capture_rate": 140
    },
    {
        "pokedex_id": 683,
        "name": "Aromatisse",
        "capture_rate": 140
    },
    {
        "pokedex_id": 685,
        "name": "Slurpuff",
        "capture_rate": 140
    },
    {
        "pokedex_id": 759,
        "name": "Stufful",
        "capture_rate": 140
    },
    {
        "pokedex_id": 769,
        "name": "Sandygast",
        "capture_rate": 140
    },
    {
        "pokedex_id": 440,
        "name": "Happiny",
        "capture_rate": 130
    },
    {
        "pokedex_id": 599,
        "name": "Klink",
        "capture_rate": 130
    },
    {
        "pokedex_id": 20,
        "name": "Raticate",
        "capture_rate": 127
    },
    {
        "pokedex_id": 262,
        "name": "Mightyena",
        "capture_rate": 127
    },
    {
        "pokedex_id": 400,
        "name": "Bibarel",
        "capture_rate": 127
    },
    {
        "pokedex_id": 660,
        "name": "Diggersby",
        "capture_rate": 127
    },
    {
        "pokedex_id": 735,
        "name": "Gumshoos",
        "capture_rate": 127
    },
    {
        "pokedex_id": 828,
        "name": "Thievul",
        "capture_rate": 127
    },
    {
        "pokedex_id": 832,
        "name": "Dubwool",
        "capture_rate": 127
    },
    {
        "pokedex_id": 320,
        "name": "Wailmer",
        "capture_rate": 125
    },
    {
        "pokedex_id": 360,
        "name": "Wynaut",
        "capture_rate": 125
    },
    {
        "pokedex_id": 425,
        "name": "Drifloon",
        "capture_rate": 125
    },
    {
        "pokedex_id": 11,
        "name": "Metapod",
        "capture_rate": 120
    },
    {
        "pokedex_id": 14,
        "name": "Kakuna",
        "capture_rate": 120
    },
    {
        "pokedex_id": 17,
        "name": "Pidgeotto",
        "capture_rate": 120
    },
    {
        "pokedex_id": 30,
        "name": "Nidorina",
        "capture_rate": 120
    },
    {
        "pokedex_id": 33,
        "name": "Nidorino",
        "capture_rate": 120
    },
    {
        "pokedex_id": 44,
        "name": "Gloom",
        "capture_rate": 120
    },
    {
        "pokedex_id": 61,
        "name": "Poliwhirl",
        "capture_rate": 120
    },
    {
        "pokedex_id": 70,
        "name": "Weepinbell",
        "capture_rate": 120
    },
    {
        "pokedex_id": 75,
        "name": "Graveler",
        "capture_rate": 120
    },
    {
        "pokedex_id": 111,
        "name": "Rhyhorn",
        "capture_rate": 120
    },
    {
        "pokedex_id": 180,
        "name": "Flaaffy",
        "capture_rate": 120
    },
    {
        "pokedex_id": 188,
        "name": "Skiploom",
        "capture_rate": 120
    },
    {
        "pokedex_id": 192,
        "name": "Sunflora",
        "capture_rate": 120
    },
    {
        "pokedex_id": 216,
        "name": "Teddiursa",
        "capture_rate": 120
    },
    {
        "pokedex_id": 228,
        "name": "Houndour",
        "capture_rate": 120
    },
    {
        "pokedex_id": 231,
        "name": "Phanpy",
        "capture_rate": 120
    },
    {
        "pokedex_id": 266,
        "name": "Silcoon",
        "capture_rate": 120
    },
    {
        "pokedex_id": 268,
        "name": "Cascoon",
        "capture_rate": 120
    },
    {
        "pokedex_id": 271,
        "name": "Lombre",
        "capture_rate": 120
    },
    {
        "pokedex_id": 274,
        "name": "Nuzleaf",
        "capture_rate": 120
    },
    {
        "pokedex_id": 281,
        "name": "Kirlia",
        "capture_rate": 120
    },
    {
        "pokedex_id": 288,
        "name": "Vigoroth",
        "capture_rate": 120
    },
    {
        "pokedex_id": 291,
        "name": "Ninjask",
        "capture_rate": 120
    },
    {
        "pokedex_id": 294,
        "name": "Loudred",
        "capture_rate": 120
    },
    {
        "pokedex_id": 309,
        "name": "Electrike",
        "capture_rate": 120
    },
    {
        "pokedex_id": 329,
        "name": "Vibrava",
        "capture_rate": 120
    },
    {
        "pokedex_id": 364,
        "name": "Sealeo",
        "capture_rate": 120
    },
    {
        "pokedex_id": 397,
        "name": "Staravia",
        "capture_rate": 120
    },
    {
        "pokedex_id": 404,
        "name": "Luxio",
        "capture_rate": 120
    },
    {
        "pokedex_id": 412,
        "name": "Burmy",
        "capture_rate": 120
    },
    {
        "pokedex_id": 415,
        "name": "Combee",
        "capture_rate": 120
    },
    {
        "pokedex_id": 433,
        "name": "Chingling",
        "capture_rate": 120
    },
    {
        "pokedex_id": 451,
        "name": "Skorupi",
        "capture_rate": 120
    },
    {
        "pokedex_id": 459,
        "name": "Snover",
        "capture_rate": 120
    },
    {
        "pokedex_id": 507,
        "name": "Herdier",
        "capture_rate": 120
    },
    {
        "pokedex_id": 520,
        "name": "Tranquill",
        "capture_rate": 120
    },
    {
        "pokedex_id": 525,
        "name": "Boldore",
        "capture_rate": 120
    },
    {
        "pokedex_id": 529,
        "name": "Drilbur",
        "capture_rate": 120
    },
    {
        "pokedex_id": 536,
        "name": "Palpitoad",
        "capture_rate": 120
    },
    {
        "pokedex_id": 541,
        "name": "Swadloon",
        "capture_rate": 120
    },
    {
        "pokedex_id": 544,
        "name": "Whirlipede",
        "capture_rate": 120
    },
    {
        "pokedex_id": 554,
        "name": "Darumaka",
        "capture_rate": 120
    },
    {
        "pokedex_id": 583,
        "name": "Vanillish",
        "capture_rate": 120
    },
    {
        "pokedex_id": 613,
        "name": "Cubchoo",
        "capture_rate": 120
    },
    {
        "pokedex_id": 624,
        "name": "Pawniard",
        "capture_rate": 120
    },
    {
        "pokedex_id": 662,
        "name": "Fletchinder",
        "capture_rate": 120
    },
    {
        "pokedex_id": 665,
        "name": "Spewpa",
        "capture_rate": 120
    },
    {
        "pokedex_id": 670,
        "name": "Floette",
        "capture_rate": 120
    },
    {
        "pokedex_id": 688,
        "name": "Binacle",
        "capture_rate": 120
    },
    {
        "pokedex_id": 708,
        "name": "Phantump",
        "capture_rate": 120
    },
    {
        "pokedex_id": 710,
        "name": "Pumpkaboo",
        "capture_rate": 120
    },
    {
        "pokedex_id": 732,
        "name": "Trumbeak",
        "capture_rate": 120
    },
    {
        "pokedex_id": 737,
        "name": "Charjabug",
        "capture_rate": 120
    },
    {
        "pokedex_id": 757,
        "name": "Salandit",
        "capture_rate": 120
    },
    {
        "pokedex_id": 762,
        "name": "Steenee",
        "capture_rate": 120
    },
    {
        "pokedex_id": 822,
        "name": "Corvisquire",
        "capture_rate": 120
    },
    {
        "pokedex_id": 825,
        "name": "Dottler",
        "capture_rate": 120
    },
    {
        "pokedex_id": 838,
        "name": "Carkol",
        "capture_rate": 120
    },
    {
        "pokedex_id": 844,
        "name": "Sandaconda",
        "capture_rate": 120
    },
    {
        "pokedex_id": 854,
        "name": "Sinistea",
        "capture_rate": 120
    },
    {
        "pokedex_id": 857,
        "name": "Hattrem",
        "capture_rate": 120
    },
    {
        "pokedex_id": 860,
        "name": "Morgrem",
        "capture_rate": 120
    },
    {
        "pokedex_id": 64,
        "name": "Kadabra",
        "capture_rate": 100
    },
    {
        "pokedex_id": 442,
        "name": "Spiritomb",
        "capture_rate": 100
    },
    {
        "pokedex_id": 575,
        "name": "Gothorita",
        "capture_rate": 100
    },
    {
        "pokedex_id": 578,
        "name": "Duosion",
        "capture_rate": 100
    },
    {
        "pokedex_id": 701,
        "name": "Hawlucha",
        "capture_rate": 100
    },
    {
        "pokedex_id": 752,
        "name": "Araquanid",
        "capture_rate": 100
    },
    {
        "pokedex_id": 869,
        "name": "Alcremie",
        "capture_rate": 100
    },
    {
        "pokedex_id": 22,
        "name": "Fearow",
        "capture_rate": 90
    },
    {
        "pokedex_id": 24,
        "name": "Arbok",
        "capture_rate": 90
    },
    {
        "pokedex_id": 28,
        "name": "Sandslash",
        "capture_rate": 90
    },
    {
        "pokedex_id": 42,
        "name": "Golbat",
        "capture_rate": 90
    },
    {
        "pokedex_id": 53,
        "name": "Persian",
        "capture_rate": 90
    },
    {
        "pokedex_id": 67,
        "name": "Machoke",
        "capture_rate": 90
    },
    {
        "pokedex_id": 93,
        "name": "Haunter",
        "capture_rate": 90
    },
    {
        "pokedex_id": 102,
        "name": "Exeggcute",
        "capture_rate": 90
    },
    {
        "pokedex_id": 162,
        "name": "Furret",
        "capture_rate": 90
    },
    {
        "pokedex_id": 164,
        "name": "Noctowl",
        "capture_rate": 90
    },
    {
        "pokedex_id": 166,
        "name": "Ledian",
        "capture_rate": 90
    },
    {
        "pokedex_id": 168,
        "name": "Ariados",
        "capture_rate": 90
    },
    {
        "pokedex_id": 169,
        "name": "Crobat",
        "capture_rate": 90
    },
    {
        "pokedex_id": 195,
        "name": "Quagsire",
        "capture_rate": 90
    },
    {
        "pokedex_id": 264,
        "name": "Linoone",
        "capture_rate": 90
    },
    {
        "pokedex_id": 286,
        "name": "Breloom",
        "capture_rate": 90
    },
    {
        "pokedex_id": 305,
        "name": "Lairon",
        "capture_rate": 90
    },
    {
        "pokedex_id": 308,
        "name": "Medicham",
        "capture_rate": 90
    },
    {
        "pokedex_id": 324,
        "name": "Torkoal",
        "capture_rate": 90
    },
    {
        "pokedex_id": 335,
        "name": "Zangoose",
        "capture_rate": 90
    },
    {
        "pokedex_id": 336,
        "name": "Seviper",
        "capture_rate": 90
    },
    {
        "pokedex_id": 344,
        "name": "Claydol",
        "capture_rate": 90
    },
    {
        "pokedex_id": 356,
        "name": "Dusclops",
        "capture_rate": 90
    },
    {
        "pokedex_id": 437,
        "name": "Bronzong",
        "capture_rate": 90
    },
    {
        "pokedex_id": 510,
        "name": "Liepard",
        "capture_rate": 90
    },
    {
        "pokedex_id": 533,
        "name": "Gurdurr",
        "capture_rate": 90
    },
    {
        "pokedex_id": 552,
        "name": "Krokorok",
        "capture_rate": 90
    },
    {
        "pokedex_id": 560,
        "name": "Scrafty",
        "capture_rate": 90
    },
    {
        "pokedex_id": 563,
        "name": "Cofagrigus",
        "capture_rate": 90
    },
    {
        "pokedex_id": 598,
        "name": "Ferrothorn",
        "capture_rate": 90
    },
    {
        "pokedex_id": 606,
        "name": "Beheeyem",
        "capture_rate": 90
    },
    {
        "pokedex_id": 608,
        "name": "Lampent",
        "capture_rate": 90
    },
    {
        "pokedex_id": 623,
        "name": "Golurk",
        "capture_rate": 90
    },
    {
        "pokedex_id": 631,
        "name": "Heatmor",
        "capture_rate": 90
    },
    {
        "pokedex_id": 632,
        "name": "Durant",
        "capture_rate": 90
    },
    {
        "pokedex_id": 680,
        "name": "Doublade",
        "capture_rate": 90
    },
    {
        "pokedex_id": 745,
        "name": "Lycanroc",
        "capture_rate": 90
    },
    {
        "pokedex_id": 767,
        "name": "Wimpod",
        "capture_rate": 90
    },
    {
        "pokedex_id": 820,
        "name": "Greedent",
        "capture_rate": 90
    },
    {
        "pokedex_id": 863,
        "name": "Perrserker",
        "capture_rate": 90
    },
    {
        "pokedex_id": 867,
        "name": "Runerigus",
        "capture_rate": 90
    },
    {
        "pokedex_id": 879,
        "name": "Copperajah",
        "capture_rate": 90
    },
    {
        "pokedex_id": 687,
        "name": "Malamar",
        "capture_rate": 80
    },
    {
        "pokedex_id": 779,
        "name": "Bruxish",
        "capture_rate": 80
    },
    {
        "pokedex_id": 26,
        "name": "Raichu",
        "capture_rate": 75
    },
    {
        "pokedex_id": 38,
        "name": "Ninetales",
        "capture_rate": 75
    },
    {
        "pokedex_id": 47,
        "name": "Parasect",
        "capture_rate": 75
    },
    {
        "pokedex_id": 49,
        "name": "Venomoth",
        "capture_rate": 75
    },
    {
        "pokedex_id": 55,
        "name": "Golduck",
        "capture_rate": 75
    },
    {
        "pokedex_id": 57,
        "name": "Primeape",
        "capture_rate": 75
    },
    {
        "pokedex_id": 59,
        "name": "Arcanine",
        "capture_rate": 75
    },
    {
        "pokedex_id": 80,
        "name": "Slowbro",
        "capture_rate": 75
    },
    {
        "pokedex_id": 87,
        "name": "Dewgong",
        "capture_rate": 75
    },
    {
        "pokedex_id": 89,
        "name": "Muk",
        "capture_rate": 75
    },
    {
        "pokedex_id": 97,
        "name": "Hypno",
        "capture_rate": 75
    },
    {
        "pokedex_id": 105,
        "name": "Marowak",
        "capture_rate": 75
    },
    {
        "pokedex_id": 117,
        "name": "Seadra",
        "capture_rate": 75
    },
    {
        "pokedex_id": 171,
        "name": "Lanturn",
        "capture_rate": 75
    },
    {
        "pokedex_id": 176,
        "name": "Togetic",
        "capture_rate": 75
    },
    {
        "pokedex_id": 178,
        "name": "Xatu",
        "capture_rate": 75
    },
    {
        "pokedex_id": 184,
        "name": "Azumarill",
        "capture_rate": 75
    },
    {
        "pokedex_id": 193,
        "name": "Yanma",
        "capture_rate": 75
    },
    {
        "pokedex_id": 205,
        "name": "Forretress",
        "capture_rate": 75
    },
    {
        "pokedex_id": 210,
        "name": "Granbull",
        "capture_rate": 75
    },
    {
        "pokedex_id": 219,
        "name": "Magcargo",
        "capture_rate": 75
    },
    {
        "pokedex_id": 221,
        "name": "Piloswine",
        "capture_rate": 75
    },
    {
        "pokedex_id": 224,
        "name": "Octillery",
        "capture_rate": 75
    },
    {
        "pokedex_id": 236,
        "name": "Tyrogue",
        "capture_rate": 75
    },
    {
        "pokedex_id": 284,
        "name": "Masquerain",
        "capture_rate": 75
    },
    {
        "pokedex_id": 317,
        "name": "Swalot",
        "capture_rate": 75
    },
    {
        "pokedex_id": 340,
        "name": "Whiscash",
        "capture_rate": 75
    },
    {
        "pokedex_id": 362,
        "name": "Glalie",
        "capture_rate": 75
    },
    {
        "pokedex_id": 407,
        "name": "Roserade",
        "capture_rate": 75
    },
    {
        "pokedex_id": 419,
        "name": "Floatzel",
        "capture_rate": 75
    },
    {
        "pokedex_id": 421,
        "name": "Cherrim",
        "capture_rate": 75
    },
    {
        "pokedex_id": 423,
        "name": "Gastrodon",
        "capture_rate": 75
    },
    {
        "pokedex_id": 432,
        "name": "Purugly",
        "capture_rate": 75
    },
    {
        "pokedex_id": 447,
        "name": "Riolu",
        "capture_rate": 75
    },
    {
        "pokedex_id": 454,
        "name": "Toxicroak",
        "capture_rate": 75
    },
    {
        "pokedex_id": 457,
        "name": "Lumineon",
        "capture_rate": 75
    },
    {
        "pokedex_id": 478,
        "name": "Froslass",
        "capture_rate": 75
    },
    {
        "pokedex_id": 512,
        "name": "Simisage",
        "capture_rate": 75
    },
    {
        "pokedex_id": 514,
        "name": "Simisear",
        "capture_rate": 75
    },
    {
        "pokedex_id": 516,
        "name": "Simipour",
        "capture_rate": 75
    },
    {
        "pokedex_id": 518,
        "name": "Musharna",
        "capture_rate": 75
    },
    {
        "pokedex_id": 523,
        "name": "Zebstrika",
        "capture_rate": 75
    },
    {
        "pokedex_id": 547,
        "name": "Whimsicott",
        "capture_rate": 75
    },
    {
        "pokedex_id": 549,
        "name": "Lilligant",
        "capture_rate": 75
    },
    {
        "pokedex_id": 558,
        "name": "Crustle",
        "capture_rate": 75
    },
    {
        "pokedex_id": 570,
        "name": "Zorua",
        "capture_rate": 75
    },
    {
        "pokedex_id": 586,
        "name": "Sawsbuck",
        "capture_rate": 75
    },
    {
        "pokedex_id": 589,
        "name": "Escavalier",
        "capture_rate": 75
    },
    {
        "pokedex_id": 591,
        "name": "Amoonguss",
        "capture_rate": 75
    },
    {
        "pokedex_id": 594,
        "name": "Alomomola",
        "capture_rate": 75
    },
    {
        "pokedex_id": 596,
        "name": "Galvantula",
        "capture_rate": 75
    },
    {
        "pokedex_id": 610,
        "name": "Axew",
        "capture_rate": 75
    },
    {
        "pokedex_id": 617,
        "name": "Accelgor",
        "capture_rate": 75
    },
    {
        "pokedex_id": 618,
        "name": "Stunfisk",
        "capture_rate": 75
    },
    {
        "pokedex_id": 678,
        "name": "Meowstic",
        "capture_rate": 75
    },
    {
        "pokedex_id": 695,
        "name": "Heliolisk",
        "capture_rate": 75
    },
    {
        "pokedex_id": 707,
        "name": "Klefki",
        "capture_rate": 75
    },
    {
        "pokedex_id": 743,
        "name": "Ribombee",
        "capture_rate": 75
    },
    {
        "pokedex_id": 748,
        "name": "Toxapex",
        "capture_rate": 75
    },
    {
        "pokedex_id": 754,
        "name": "Lurantis",
        "capture_rate": 75
    },
    {
        "pokedex_id": 756,
        "name": "Shiinotic",
        "capture_rate": 75
    },
    {
        "pokedex_id": 830,
        "name": "Eldegoss",
        "capture_rate": 75
    },
    {
        "pokedex_id": 834,
        "name": "Drednaw",
        "capture_rate": 75
    },
    {
        "pokedex_id": 848,
        "name": "Toxel",
        "capture_rate": 75
    },
    {
        "pokedex_id": 851,
        "name": "Centiskorch",
        "capture_rate": 75
    },
    {
        "pokedex_id": 871,
        "name": "Pincurchin",
        "capture_rate": 75
    },
    {
        "pokedex_id": 873,
        "name": "Frosmoth",
        "capture_rate": 75
    },
    {
        "pokedex_id": 199,
        "name": "Slowking",
        "capture_rate": 70
    },
    {
        "pokedex_id": 760,
        "name": "Bewear",
        "capture_rate": 70
    },
    {
        "pokedex_id": 776,
        "name": "Turtonator",
        "capture_rate": 70
    },
    {
        "pokedex_id": 780,
        "name": "Drampa",
        "capture_rate": 70
    },
    {
        "pokedex_id": 185,
        "name": "Sudowoodo",
        "capture_rate": 65
    },
    {
        "pokedex_id": 668,
        "name": "Pyroar",
        "capture_rate": 65
    },
    {
        "pokedex_id": 675,
        "name": "Pangoro",
        "capture_rate": 65
    },
    {
        "pokedex_id": 73,
        "name": "Tentacruel",
        "capture_rate": 60
    },
    {
        "pokedex_id": 78,
        "name": "Rapidash",
        "capture_rate": 60
    },
    {
        "pokedex_id": 82,
        "name": "Magneton",
        "capture_rate": 60
    },
    {
        "pokedex_id": 91,
        "name": "Cloyster",
        "capture_rate": 60
    },
    {
        "pokedex_id": 99,
        "name": "Kingler",
        "capture_rate": 60
    },
    {
        "pokedex_id": 101,
        "name": "Electrode",
        "capture_rate": 60
    },
    {
        "pokedex_id": 110,
        "name": "Weezing",
        "capture_rate": 60
    },
    {
        "pokedex_id": 112,
        "name": "Rhydon",
        "capture_rate": 60
    },
    {
        "pokedex_id": 119,
        "name": "Seaking",
        "capture_rate": 60
    },
    {
        "pokedex_id": 121,
        "name": "Starmie",
        "capture_rate": 60
    },
    {
        "pokedex_id": 203,
        "name": "Girafarig",
        "capture_rate": 60
    },
    {
        "pokedex_id": 207,
        "name": "Gligar",
        "capture_rate": 60
    },
    {
        "pokedex_id": 215,
        "name": "Sneasel",
        "capture_rate": 60
    },
    {
        "pokedex_id": 217,
        "name": "Ursaring",
        "capture_rate": 60
    },
    {
        "pokedex_id": 222,
        "name": "Corsola",
        "capture_rate": 60
    },
    {
        "pokedex_id": 232,
        "name": "Donphan",
        "capture_rate": 60
    },
    {
        "pokedex_id": 301,
        "name": "Delcatty",
        "capture_rate": 60
    },
    {
        "pokedex_id": 319,
        "name": "Sharpedo",
        "capture_rate": 60
    },
    {
        "pokedex_id": 321,
        "name": "Wailord",
        "capture_rate": 60
    },
    {
        "pokedex_id": 326,
        "name": "Grumpig",
        "capture_rate": 60
    },
    {
        "pokedex_id": 332,
        "name": "Cacturne",
        "capture_rate": 60
    },
    {
        "pokedex_id": 350,
        "name": "Milotic",
        "capture_rate": 60
    },
    {
        "pokedex_id": 367,
        "name": "Huntail",
        "capture_rate": 60
    },
    {
        "pokedex_id": 368,
        "name": "Gorebyss",
        "capture_rate": 60
    },
    {
        "pokedex_id": 426,
        "name": "Drifblim",
        "capture_rate": 60
    },
    {
        "pokedex_id": 428,
        "name": "Lopunny",
        "capture_rate": 60
    },
    {
        "pokedex_id": 435,
        "name": "Skuntank",
        "capture_rate": 60
    },
    {
        "pokedex_id": 450,
        "name": "Hippowdon",
        "capture_rate": 60
    },
    {
        "pokedex_id": 460,
        "name": "Abomasnow",
        "capture_rate": 60
    },
    {
        "pokedex_id": 476,
        "name": "Probopass",
        "capture_rate": 60
    },
    {
        "pokedex_id": 530,
        "name": "Excadrill",
        "capture_rate": 60
    },
    {
        "pokedex_id": 555,
        "name": "Darmanitan",
        "capture_rate": 60
    },
    {
        "pokedex_id": 569,
        "name": "Garbodor",
        "capture_rate": 60
    },
    {
        "pokedex_id": 573,
        "name": "Cinccino",
        "capture_rate": 60
    },
    {
        "pokedex_id": 593,
        "name": "Jellicent",
        "capture_rate": 60
    },
    {
        "pokedex_id": 600,
        "name": "Klang",
        "capture_rate": 60
    },
    {
        "pokedex_id": 603,
        "name": "Eelektrik",
        "capture_rate": 60
    },
    {
        "pokedex_id": 611,
        "name": "Fraxure",
        "capture_rate": 60
    },
    {
        "pokedex_id": 614,
        "name": "Beartic",
        "capture_rate": 60
    },
    {
        "pokedex_id": 628,
        "name": "Braviary",
        "capture_rate": 60
    },
    {
        "pokedex_id": 630,
        "name": "Mandibuzz",
        "capture_rate": 60
    },
    {
        "pokedex_id": 703,
        "name": "Carbink",
        "capture_rate": 60
    },
    {
        "pokedex_id": 709,
        "name": "Trevenant",
        "capture_rate": 60
    },
    {
        "pokedex_id": 711,
        "name": "Gourgeist",
        "capture_rate": 60
    },
    {
        "pokedex_id": 740,
        "name": "Crabominable",
        "capture_rate": 60
    },
    {
        "pokedex_id": 746,
        "name": "Wishiwashi",
        "capture_rate": 60
    },
    {
        "pokedex_id": 750,
        "name": "Mudsdale",
        "capture_rate": 60
    },
    {
        "pokedex_id": 764,
        "name": "Comfey",
        "capture_rate": 60
    },
    {
        "pokedex_id": 770,
        "name": "Palossand",
        "capture_rate": 60
    },
    {
        "pokedex_id": 771,
        "name": "Pyukumuku",
        "capture_rate": 60
    },
    {
        "pokedex_id": 847,
        "name": "Barraskewda",
        "capture_rate": 60
    },
    {
        "pokedex_id": 855,
        "name": "Polteageist",
        "capture_rate": 60
    },
    {
        "pokedex_id": 874,
        "name": "Stonjourner",
        "capture_rate": 60
    },
    {
        "pokedex_id": 875,
        "name": "Eiscue",
        "capture_rate": 60
    },
    {
        "pokedex_id": 691,
        "name": "Dragalge",
        "capture_rate": 55
    },
    {
        "pokedex_id": 693,
        "name": "Clawitzer",
        "capture_rate": 55
    },
    {
        "pokedex_id": 713,
        "name": "Avalugg",
        "capture_rate": 55
    },
    {
        "pokedex_id": 40,
        "name": "Wigglytuff",
        "capture_rate": 50
    },
    {
        "pokedex_id": 51,
        "name": "Dugtrio",
        "capture_rate": 50
    },
    {
        "pokedex_id": 65,
        "name": "Alakazam",
        "capture_rate": 50
    },
    {
        "pokedex_id": 446,
        "name": "Munchlax",
        "capture_rate": 50
    },
    {
        "pokedex_id": 473,
        "name": "Mamoswine",
        "capture_rate": 50
    },
    {
        "pokedex_id": 576,
        "name": "Gothitelle",
        "capture_rate": 50
    },
    {
        "pokedex_id": 579,
        "name": "Reuniclus",
        "capture_rate": 50
    },
    {
        "pokedex_id": 1,
        "name": "Bulbasaur",
        "capture_rate": 45
    },
    {
        "pokedex_id": 2,
        "name": "Ivysaur",
        "capture_rate": 45
    },
    {
        "pokedex_id": 3,
        "name": "Venusaur",
        "capture_rate": 45
    },
    {
        "pokedex_id": 4,
        "name": "Charmander",
        "capture_rate": 45
    },
    {
        "pokedex_id": 5,
        "name": "Charmeleon",
        "capture_rate": 45
    },
    {
        "pokedex_id": 6,
        "name": "Charizard",
        "capture_rate": 45
    },
    {
        "pokedex_id": 7,
        "name": "Squirtle",
        "capture_rate": 45
    },
    {
        "pokedex_id": 8,
        "name": "Wartortle",
        "capture_rate": 45
    },
    {
        "pokedex_id": 9,
        "name": "Blastoise",
        "capture_rate": 45
    },
    {
        "pokedex_id": 12,
        "name": "Butterfree",
        "capture_rate": 45
    },
    {
        "pokedex_id": 15,
        "name": "Beedrill",
        "capture_rate": 45
    },
    {
        "pokedex_id": 18,
        "name": "Pidgeot",
        "capture_rate": 45
    },
    {
        "pokedex_id": 31,
        "name": "Nidoqueen",
        "capture_rate": 45
    },
    {
        "pokedex_id": 34,
        "name": "Nidoking",
        "capture_rate": 45
    },
    {
        "pokedex_id": 45,
        "name": "Vileplume",
        "capture_rate": 45
    },
    {
        "pokedex_id": 62,
        "name": "Poliwrath",
        "capture_rate": 45
    },
    {
        "pokedex_id": 68,
        "name": "Machamp",
        "capture_rate": 45
    },
    {
        "pokedex_id": 71,
        "name": "Victreebel",
        "capture_rate": 45
    },
    {
        "pokedex_id": 76,
        "name": "Golem",
        "capture_rate": 45
    },
    {
        "pokedex_id": 83,
        "name": "Farfetch'd",
        "capture_rate": 45
    },
    {
        "pokedex_id": 85,
        "name": "Dodrio",
        "capture_rate": 45
    },
    {
        "pokedex_id": 94,
        "name": "Gengar",
        "capture_rate": 45
    },
    {
        "pokedex_id": 95,
        "name": "Onix",
        "capture_rate": 45
    },
    {
        "pokedex_id": 103,
        "name": "Exeggutor",
        "capture_rate": 45
    },
    {
        "pokedex_id": 106,
        "name": "Hitmonlee",
        "capture_rate": 45
    },
    {
        "pokedex_id": 107,
        "name": "Hitmonchan",
        "capture_rate": 45
    },
    {
        "pokedex_id": 108,
        "name": "Lickitung",
        "capture_rate": 45
    },
    {
        "pokedex_id": 114,
        "name": "Tangela",
        "capture_rate": 45
    },
    {
        "pokedex_id": 115,
        "name": "Kangaskhan",
        "capture_rate": 45
    },
    {
        "pokedex_id": 122,
        "name": "Mr. Mime",
        "capture_rate": 45
    },
    {
        "pokedex_id": 123,
        "name": "Scyther",
        "capture_rate": 45
    },
    {
        "pokedex_id": 124,
        "name": "Jynx",
        "capture_rate": 45
    },
    {
        "pokedex_id": 125,
        "name": "Electabuzz",
        "capture_rate": 45
    },
    {
        "pokedex_id": 126,
        "name": "Magmar",
        "capture_rate": 45
    },
    {
        "pokedex_id": 127,
        "name": "Pinsir",
        "capture_rate": 45
    },
    {
        "pokedex_id": 128,
        "name": "Tauros",
        "capture_rate": 45
    },
    {
        "pokedex_id": 130,
        "name": "Gyarados",
        "capture_rate": 45
    },
    {
        "pokedex_id": 131,
        "name": "Lapras",
        "capture_rate": 45
    },
    {
        "pokedex_id": 133,
        "name": "Eevee",
        "capture_rate": 45
    },
    {
        "pokedex_id": 134,
        "name": "Vaporeon",
        "capture_rate": 45
    },
    {
        "pokedex_id": 135,
        "name": "Jolteon",
        "capture_rate": 45
    },
    {
        "pokedex_id": 136,
        "name": "Flareon",
        "capture_rate": 45
    },
    {
        "pokedex_id": 137,
        "name": "Porygon",
        "capture_rate": 45
    },
    {
        "pokedex_id": 138,
        "name": "Omanyte",
        "capture_rate": 45
    },
    {
        "pokedex_id": 139,
        "name": "Omastar",
        "capture_rate": 45
    },
    {
        "pokedex_id": 140,
        "name": "Kabuto",
        "capture_rate": 45
    },
    {
        "pokedex_id": 141,
        "name": "Kabutops",
        "capture_rate": 45
    },
    {
        "pokedex_id": 142,
        "name": "Aerodactyl",
        "capture_rate": 45
    },
    {
        "pokedex_id": 147,
        "name": "Dratini",
        "capture_rate": 45
    },
    {
        "pokedex_id": 148,
        "name": "Dragonair",
        "capture_rate": 45
    },
    {
        "pokedex_id": 149,
        "name": "Dragonite",
        "capture_rate": 45
    },
    {
        "pokedex_id": 151,
        "name": "Mew",
        "capture_rate": 45
    },
    {
        "pokedex_id": 152,
        "name": "Chikorita",
        "capture_rate": 45
    },
    {
        "pokedex_id": 153,
        "name": "Bayleef",
        "capture_rate": 45
    },
    {
        "pokedex_id": 154,
        "name": "Meganium",
        "capture_rate": 45
    },
    {
        "pokedex_id": 155,
        "name": "Cyndaquil",
        "capture_rate": 45
    },
    {
        "pokedex_id": 156,
        "name": "Quilava",
        "capture_rate": 45
    },
    {
        "pokedex_id": 157,
        "name": "Typhlosion",
        "capture_rate": 45
    },
    {
        "pokedex_id": 158,
        "name": "Totodile",
        "capture_rate": 45
    },
    {
        "pokedex_id": 159,
        "name": "Croconaw",
        "capture_rate": 45
    },
    {
        "pokedex_id": 160,
        "name": "Feraligatr",
        "capture_rate": 45
    },
    {
        "pokedex_id": 181,
        "name": "Ampharos",
        "capture_rate": 45
    },
    {
        "pokedex_id": 182,
        "name": "Bellossom",
        "capture_rate": 45
    },
    {
        "pokedex_id": 186,
        "name": "Politoed",
        "capture_rate": 45
    },
    {
        "pokedex_id": 189,
        "name": "Jumpluff",
        "capture_rate": 45
    },
    {
        "pokedex_id": 190,
        "name": "Aipom",
        "capture_rate": 45
    },
    {
        "pokedex_id": 196,
        "name": "Espeon",
        "capture_rate": 45
    },
    {
        "pokedex_id": 197,
        "name": "Umbreon",
        "capture_rate": 45
    },
    {
        "pokedex_id": 200,
        "name": "Misdreavus",
        "capture_rate": 45
    },
    {
        "pokedex_id": 202,
        "name": "Wobbuffet",
        "capture_rate": 45
    },
    {
        "pokedex_id": 211,
        "name": "Qwilfish",
        "capture_rate": 45
    },
    {
        "pokedex_id": 214,
        "name": "Heracross",
        "capture_rate": 45
    },
    {
        "pokedex_id": 225,
        "name": "Delibird",
        "capture_rate": 45
    },
    {
        "pokedex_id": 229,
        "name": "Houndoom",
        "capture_rate": 45
    },
    {
        "pokedex_id": 230,
        "name": "Kingdra",
        "capture_rate": 45
    },
    {
        "pokedex_id": 233,
        "name": "Porygon2",
        "capture_rate": 45
    },
    {
        "pokedex_id": 234,
        "name": "Stantler",
        "capture_rate": 45
    },
    {
        "pokedex_id": 235,
        "name": "Smeargle",
        "capture_rate": 45
    },
    {
        "pokedex_id": 237,
        "name": "Hitmontop",
        "capture_rate": 45
    },
    {
        "pokedex_id": 238,
        "name": "Smoochum",
        "capture_rate": 45
    },
    {
        "pokedex_id": 239,
        "name": "Elekid",
        "capture_rate": 45
    },
    {
        "pokedex_id": 240,
        "name": "Magby",
        "capture_rate": 45
    },
    {
        "pokedex_id": 241,
        "name": "Miltank",
        "capture_rate": 45
    },
    {
        "pokedex_id": 246,
        "name": "Larvitar",
        "capture_rate": 45
    },
    {
        "pokedex_id": 247,
        "name": "Pupitar",
        "capture_rate": 45
    },
    {
        "pokedex_id": 248,
        "name": "Tyranitar",
        "capture_rate": 45
    },
    {
        "pokedex_id": 251,
        "name": "Celebi",
        "capture_rate": 45
    },
    {
        "pokedex_id": 252,
        "name": "Treecko",
        "capture_rate": 45
    },
    {
        "pokedex_id": 253,
        "name": "Grovyle",
        "capture_rate": 45
    },
    {
        "pokedex_id": 254,
        "name": "Sceptile",
        "capture_rate": 45
    },
    {
        "pokedex_id": 255,
        "name": "Torchic",
        "capture_rate": 45
    },
    {
        "pokedex_id": 256,
        "name": "Combusken",
        "capture_rate": 45
    },
    {
        "pokedex_id": 257,
        "name": "Blaziken",
        "capture_rate": 45
    },
    {
        "pokedex_id": 258,
        "name": "Mudkip",
        "capture_rate": 45
    },
    {
        "pokedex_id": 259,
        "name": "Marshtomp",
        "capture_rate": 45
    },
    {
        "pokedex_id": 260,
        "name": "Swampert",
        "capture_rate": 45
    },
    {
        "pokedex_id": 267,
        "name": "Beautifly",
        "capture_rate": 45
    },
    {
        "pokedex_id": 269,
        "name": "Dustox",
        "capture_rate": 45
    },
    {
        "pokedex_id": 272,
        "name": "Ludicolo",
        "capture_rate": 45
    },
    {
        "pokedex_id": 275,
        "name": "Shiftry",
        "capture_rate": 45
    },
    {
        "pokedex_id": 277,
        "name": "Swellow",
        "capture_rate": 45
    },
    {
        "pokedex_id": 279,
        "name": "Pelipper",
        "capture_rate": 45
    },
    {
        "pokedex_id": 282,
        "name": "Gardevoir",
        "capture_rate": 45
    },
    {
        "pokedex_id": 289,
        "name": "Slaking",
        "capture_rate": 45
    },
    {
        "pokedex_id": 292,
        "name": "Shedinja",
        "capture_rate": 45
    },
    {
        "pokedex_id": 295,
        "name": "Exploud",
        "capture_rate": 45
    },
    {
        "pokedex_id": 302,
        "name": "Sableye",
        "capture_rate": 45
    },
    {
        "pokedex_id": 303,
        "name": "Mawile",
        "capture_rate": 45
    },
    {
        "pokedex_id": 306,
        "name": "Aggron",
        "capture_rate": 45
    },
    {
        "pokedex_id": 310,
        "name": "Manectric",
        "capture_rate": 45
    },
    {
        "pokedex_id": 330,
        "name": "Flygon",
        "capture_rate": 45
    },
    {
        "pokedex_id": 334,
        "name": "Altaria",
        "capture_rate": 45
    },
    {
        "pokedex_id": 337,
        "name": "Lunatone",
        "capture_rate": 45
    },
    {
        "pokedex_id": 338,
        "name": "Solrock",
        "capture_rate": 45
    },
    {
        "pokedex_id": 345,
        "name": "Lileep",
        "capture_rate": 45
    },
    {
        "pokedex_id": 346,
        "name": "Cradily",
        "capture_rate": 45
    },
    {
        "pokedex_id": 347,
        "name": "Anorith",
        "capture_rate": 45
    },
    {
        "pokedex_id": 348,
        "name": "Armaldo",
        "capture_rate": 45
    },
    {
        "pokedex_id": 351,
        "name": "Castform",
        "capture_rate": 45
    },
    {
        "pokedex_id": 354,
        "name": "Banette",
        "capture_rate": 45
    },
    {
        "pokedex_id": 358,
        "name": "Chimecho",
        "capture_rate": 45
    },
    {
        "pokedex_id": 365,
        "name": "Walrein",
        "capture_rate": 45
    },
    {
        "pokedex_id": 371,
        "name": "Bagon",
        "capture_rate": 45
    },
    {
        "pokedex_id": 372,
        "name": "Shelgon",
        "capture_rate": 45
    },
    {
        "pokedex_id": 373,
        "name": "Salamence",
        "capture_rate": 45
    },
    {
        "pokedex_id": 384,
        "name": "Rayquaza",
        "capture_rate": 45
    },
    {
        "pokedex_id": 387,
        "name": "Turtwig",
        "capture_rate": 45
    },
    {
        "pokedex_id": 388,
        "name": "Grotle",
        "capture_rate": 45
    },
    {
        "pokedex_id": 389,
        "name": "Torterra",
        "capture_rate": 45
    },
    {
        "pokedex_id": 390,
        "name": "Chimchar",
        "capture_rate": 45
    },
    {
        "pokedex_id": 391,
        "name": "Monferno",
        "capture_rate": 45
    },
    {
        "pokedex_id": 392,
        "name": "Infernape",
        "capture_rate": 45
    },
    {
        "pokedex_id": 393,
        "name": "Piplup",
        "capture_rate": 45
    },
    {
        "pokedex_id": 394,
        "name": "Prinplup",
        "capture_rate": 45
    },
    {
        "pokedex_id": 395,
        "name": "Empoleon",
        "capture_rate": 45
    },
    {
        "pokedex_id": 398,
        "name": "Staraptor",
        "capture_rate": 45
    },
    {
        "pokedex_id": 402,
        "name": "Kricketune",
        "capture_rate": 45
    },
    {
        "pokedex_id": 405,
        "name": "Luxray",
        "capture_rate": 45
    },
    {
        "pokedex_id": 408,
        "name": "Cranidos",
        "capture_rate": 45
    },
    {
        "pokedex_id": 409,
        "name": "Rampardos",
        "capture_rate": 45
    },
    {
        "pokedex_id": 410,
        "name": "Shieldon",
        "capture_rate": 45
    },
    {
        "pokedex_id": 411,
        "name": "Bastiodon",
        "capture_rate": 45
    },
    {
        "pokedex_id": 413,
        "name": "Wormadam",
        "capture_rate": 45
    },
    {
        "pokedex_id": 414,
        "name": "Mothim",
        "capture_rate": 45
    },
    {
        "pokedex_id": 416,
        "name": "Vespiquen",
        "capture_rate": 45
    },
    {
        "pokedex_id": 424,
        "name": "Ambipom",
        "capture_rate": 45
    },
    {
        "pokedex_id": 429,
        "name": "Mismagius",
        "capture_rate": 45
    },
    {
        "pokedex_id": 443,
        "name": "Gible",
        "capture_rate": 45
    },
    {
        "pokedex_id": 444,
        "name": "Gabite",
        "capture_rate": 45
    },
    {
        "pokedex_id": 445,
        "name": "Garchomp",
        "capture_rate": 45
    },
    {
        "pokedex_id": 448,
        "name": "Lucario",
        "capture_rate": 45
    },
    {
        "pokedex_id": 452,
        "name": "Drapion",
        "capture_rate": 45
    },
    {
        "pokedex_id": 461,
        "name": "Weavile",
        "capture_rate": 45
    },
    {
        "pokedex_id": 470,
        "name": "Leafeon",
        "capture_rate": 45
    },
    {
        "pokedex_id": 471,
        "name": "Glaceon",
        "capture_rate": 45
    },
    {
        "pokedex_id": 475,
        "name": "Gallade",
        "capture_rate": 45
    },
    {
        "pokedex_id": 477,
        "name": "Dusknoir",
        "capture_rate": 45
    },
    {
        "pokedex_id": 479,
        "name": "Rotom",
        "capture_rate": 45
    },
    {
        "pokedex_id": 492,
        "name": "Shaymin",
        "capture_rate": 45
    },
    {
        "pokedex_id": 495,
        "name": "Snivy",
        "capture_rate": 45
    },
    {
        "pokedex_id": 496,
        "name": "Servine",
        "capture_rate": 45
    },
    {
        "pokedex_id": 497,
        "name": "Serperior",
        "capture_rate": 45
    },
    {
        "pokedex_id": 498,
        "name": "Tepig",
        "capture_rate": 45
    },
    {
        "pokedex_id": 499,
        "name": "Pignite",
        "capture_rate": 45
    },
    {
        "pokedex_id": 500,
        "name": "Emboar",
        "capture_rate": 45
    },
    {
        "pokedex_id": 501,
        "name": "Oshawott",
        "capture_rate": 45
    },
    {
        "pokedex_id": 502,
        "name": "Dewott",
        "capture_rate": 45
    },
    {
        "pokedex_id": 503,
        "name": "Samurott",
        "capture_rate": 45
    },
    {
        "pokedex_id": 508,
        "name": "Stoutland",
        "capture_rate": 45
    },
    {
        "pokedex_id": 521,
        "name": "Unfezant",
        "capture_rate": 45
    },
    {
        "pokedex_id": 526,
        "name": "Gigalith",
        "capture_rate": 45
    },
    {
        "pokedex_id": 528,
        "name": "Swoobat",
        "capture_rate": 45
    },
    {
        "pokedex_id": 534,
        "name": "Conkeldurr",
        "capture_rate": 45
    },
    {
        "pokedex_id": 537,
        "name": "Seismitoad",
        "capture_rate": 45
    },
    {
        "pokedex_id": 538,
        "name": "Throh",
        "capture_rate": 45
    },
    {
        "pokedex_id": 539,
        "name": "Sawk",
        "capture_rate": 45
    },
    {
        "pokedex_id": 542,
        "name": "Leavanny",
        "capture_rate": 45
    },
    {
        "pokedex_id": 545,
        "name": "Scolipede",
        "capture_rate": 45
    },
    {
        "pokedex_id": 553,
        "name": "Krookodile",
        "capture_rate": 45
    },
    {
        "pokedex_id": 561,
        "name": "Sigilyph",
        "capture_rate": 45
    },
    {
        "pokedex_id": 564,
        "name": "Tirtouga",
        "capture_rate": 45
    },
    {
        "pokedex_id": 565,
        "name": "Carracosta",
        "capture_rate": 45
    },
    {
        "pokedex_id": 566,
        "name": "Archen",
        "capture_rate": 45
    },
    {
        "pokedex_id": 567,
        "name": "Archeops",
        "capture_rate": 45
    },
    {
        "pokedex_id": 571,
        "name": "Zoroark",
        "capture_rate": 45
    },
    {
        "pokedex_id": 581,
        "name": "Swanna",
        "capture_rate": 45
    },
    {
        "pokedex_id": 584,
        "name": "Vanilluxe",
        "capture_rate": 45
    },
    {
        "pokedex_id": 609,
        "name": "Chandelure",
        "capture_rate": 45
    },
    {
        "pokedex_id": 612,
        "name": "Haxorus",
        "capture_rate": 45
    },
    {
        "pokedex_id": 620,
        "name": "Mienshao",
        "capture_rate": 45
    },
    {
        "pokedex_id": 621,
        "name": "Druddigon",
        "capture_rate": 45
    },
    {
        "pokedex_id": 625,
        "name": "Bisharp",
        "capture_rate": 45
    },
    {
        "pokedex_id": 626,
        "name": "Bouffalant",
        "capture_rate": 45
    },
    {
        "pokedex_id": 633,
        "name": "Deino",
        "capture_rate": 45
    },
    {
        "pokedex_id": 634,
        "name": "Zweilous",
        "capture_rate": 45
    },
    {
        "pokedex_id": 635,
        "name": "Hydreigon",
        "capture_rate": 45
    },
    {
        "pokedex_id": 636,
        "name": "Larvesta",
        "capture_rate": 45
    },
    {
        "pokedex_id": 650,
        "name": "Chespin",
        "capture_rate": 45
    },
    {
        "pokedex_id": 651,
        "name": "Quilladin",
        "capture_rate": 45
    },
    {
        "pokedex_id": 652,
        "name": "Chesnaught",
        "capture_rate": 45
    },
    {
        "pokedex_id": 653,
        "name": "Fennekin",
        "capture_rate": 45
    },
    {
        "pokedex_id": 654,
        "name": "Braixen",
        "capture_rate": 45
    },
    {
        "pokedex_id": 655,
        "name": "Delphox",
        "capture_rate": 45
    },
    {
        "pokedex_id": 656,
        "name": "Froakie",
        "capture_rate": 45
    },
    {
        "pokedex_id": 657,
        "name": "Frogadier",
        "capture_rate": 45
    },
    {
        "pokedex_id": 658,
        "name": "Greninja",
        "capture_rate": 45
    },
    {
        "pokedex_id": 663,
        "name": "Talonflame",
        "capture_rate": 45
    },
    {
        "pokedex_id": 666,
        "name": "Vivillon",
        "capture_rate": 45
    },
    {
        "pokedex_id": 671,
        "name": "Florges",
        "capture_rate": 45
    },
    {
        "pokedex_id": 673,
        "name": "Gogoat",
        "capture_rate": 45
    },
    {
        "pokedex_id": 681,
        "name": "Aegislash",
        "capture_rate": 45
    },
    {
        "pokedex_id": 689,
        "name": "Barbaracle",
        "capture_rate": 45
    },
    {
        "pokedex_id": 696,
        "name": "Tyrunt",
        "capture_rate": 45
    },
    {
        "pokedex_id": 697,
        "name": "Tyrantrum",
        "capture_rate": 45
    },
    {
        "pokedex_id": 698,
        "name": "Amaura",
        "capture_rate": 45
    },
    {
        "pokedex_id": 699,
        "name": "Aurorus",
        "capture_rate": 45
    },
    {
        "pokedex_id": 700,
        "name": "Sylveon",
        "capture_rate": 45
    },
    {
        "pokedex_id": 704,
        "name": "Goomy",
        "capture_rate": 45
    },
    {
        "pokedex_id": 705,
        "name": "Sliggoo",
        "capture_rate": 45
    },
    {
        "pokedex_id": 706,
        "name": "Goodra",
        "capture_rate": 45
    },
    {
        "pokedex_id": 715,
        "name": "Noivern",
        "capture_rate": 45
    },
    {
        "pokedex_id": 716,
        "name": "Xerneas",
        "capture_rate": 45
    },
    {
        "pokedex_id": 717,
        "name": "Yveltal",
        "capture_rate": 45
    },
    {
        "pokedex_id": 722,
        "name": "Rowlet",
        "capture_rate": 45
    },
    {
        "pokedex_id": 723,
        "name": "Dartrix",
        "capture_rate": 45
    },
    {
        "pokedex_id": 724,
        "name": "Decidueye",
        "capture_rate": 45
    },
    {
        "pokedex_id": 725,
        "name": "Litten",
        "capture_rate": 45
    },
    {
        "pokedex_id": 726,
        "name": "Torracat",
        "capture_rate": 45
    },
    {
        "pokedex_id": 727,
        "name": "Incineroar",
        "capture_rate": 45
    },
    {
        "pokedex_id": 728,
        "name": "Popplio",
        "capture_rate": 45
    },
    {
        "pokedex_id": 729,
        "name": "Brionne",
        "capture_rate": 45
    },
    {
        "pokedex_id": 730,
        "name": "Primarina",
        "capture_rate": 45
    },
    {
        "pokedex_id": 733,
        "name": "Toucannon",
        "capture_rate": 45
    },
    {
        "pokedex_id": 738,
        "name": "Vikavolt",
        "capture_rate": 45
    },
    {
        "pokedex_id": 741,
        "name": "Oricorio",
        "capture_rate": 45
    },
    {
        "pokedex_id": 758,
        "name": "Salazzle",
        "capture_rate": 45
    },
    {
        "pokedex_id": 763,
        "name": "Tsareena",
        "capture_rate": 45
    },
    {
        "pokedex_id": 765,
        "name": "Oranguru",
        "capture_rate": 45
    },
    {
        "pokedex_id": 766,
        "name": "Passimian",
        "capture_rate": 45
    },
    {
        "pokedex_id": 768,
        "name": "Golisopod",
        "capture_rate": 45
    },
    {
        "pokedex_id": 775,
        "name": "Komala",
        "capture_rate": 45
    },
    {
        "pokedex_id": 778,
        "name": "Mimikyu",
        "capture_rate": 45
    },
    {
        "pokedex_id": 782,
        "name": "Jangmo-o",
        "capture_rate": 45
    },
    {
        "pokedex_id": 783,
        "name": "Hakamo-o",
        "capture_rate": 45
    },
    {
        "pokedex_id": 784,
        "name": "Kommo-o",
        "capture_rate": 45
    },
    {
        "pokedex_id": 789,
        "name": "Cosmog",
        "capture_rate": 45
    },
    {
        "pokedex_id": 790,
        "name": "Cosmoem",
        "capture_rate": 45
    },
    {
        "pokedex_id": 791,
        "name": "Solgaleo",
        "capture_rate": 45
    },
    {
        "pokedex_id": 792,
        "name": "Lunala",
        "capture_rate": 45
    },
    {
        "pokedex_id": 793,
        "name": "Nihilego",
        "capture_rate": 45
    },
    {
        "pokedex_id": 794,
        "name": "Buzzwole",
        "capture_rate": 45
    },
    {
        "pokedex_id": 795,
        "name": "Pheromosa",
        "capture_rate": 45
    },
    {
        "pokedex_id": 796,
        "name": "Xurkitree",
        "capture_rate": 45
    },
    {
        "pokedex_id": 797,
        "name": "Celesteela",
        "capture_rate": 45
    },
    {
        "pokedex_id": 798,
        "name": "Kartana",
        "capture_rate": 45
    },
    {
        "pokedex_id": 799,
        "name": "Guzzlord",
        "capture_rate": 45
    },
    {
        "pokedex_id": 803,
        "name": "Poipole",
        "capture_rate": 45
    },
    {
        "pokedex_id": 804,
        "name": "Naganadel",
        "capture_rate": 45
    },
    {
        "pokedex_id": 810,
        "name": "Grookey",
        "capture_rate": 45
    },
    {
        "pokedex_id": 811,
        "name": "Thwackey",
        "capture_rate": 45
    },
    {
        "pokedex_id": 812,
        "name": "Rillaboom",
        "capture_rate": 45
    },
    {
        "pokedex_id": 813,
        "name": "Scorbunny",
        "capture_rate": 45
    },
    {
        "pokedex_id": 814,
        "name": "Raboot",
        "capture_rate": 45
    },
    {
        "pokedex_id": 815,
        "name": "Cinderace",
        "capture_rate": 45
    },
    {
        "pokedex_id": 816,
        "name": "Sobble",
        "capture_rate": 45
    },
    {
        "pokedex_id": 817,
        "name": "Drizzile",
        "capture_rate": 45
    },
    {
        "pokedex_id": 818,
        "name": "Inteleon",
        "capture_rate": 45
    },
    {
        "pokedex_id": 823,
        "name": "Corviknight",
        "capture_rate": 45
    },
    {
        "pokedex_id": 826,
        "name": "Orbeetle",
        "capture_rate": 45
    },
    {
        "pokedex_id": 836,
        "name": "Boltund",
        "capture_rate": 45
    },
    {
        "pokedex_id": 839,
        "name": "Coalossal",
        "capture_rate": 45
    },
    {
        "pokedex_id": 841,
        "name": "Flapple",
        "capture_rate": 45
    },
    {
        "pokedex_id": 842,
        "name": "Appletun",
        "capture_rate": 45
    },
    {
        "pokedex_id": 845,
        "name": "Cramorant",
        "capture_rate": 45
    },
    {
        "pokedex_id": 849,
        "name": "Toxtricity",
        "capture_rate": 45
    },
    {
        "pokedex_id": 853,
        "name": "Grapploct",
        "capture_rate": 45
    },
    {
        "pokedex_id": 858,
        "name": "Hatterene",
        "capture_rate": 45
    },
    {
        "pokedex_id": 861,
        "name": "Grimmsnarl",
        "capture_rate": 45
    },
    {
        "pokedex_id": 862,
        "name": "Obstagoon",
        "capture_rate": 45
    },
    {
        "pokedex_id": 865,
        "name": "Sirfetch'd",
        "capture_rate": 45
    },
    {
        "pokedex_id": 866,
        "name": "Mr. Rime",
        "capture_rate": 45
    },
    {
        "pokedex_id": 870,
        "name": "Falinks",
        "capture_rate": 45
    },
    {
        "pokedex_id": 880,
        "name": "Dracozolt",
        "capture_rate": 45
    },
    {
        "pokedex_id": 881,
        "name": "Arctozolt",
        "capture_rate": 45
    },
    {
        "pokedex_id": 882,
        "name": "Dracovish",
        "capture_rate": 45
    },
    {
        "pokedex_id": 883,
        "name": "Arctovish",
        "capture_rate": 45
    },
    {
        "pokedex_id": 884,
        "name": "Duraludon",
        "capture_rate": 45
    },
    {
        "pokedex_id": 885,
        "name": "Dreepy",
        "capture_rate": 45
    },
    {
        "pokedex_id": 886,
        "name": "Drakloak",
        "capture_rate": 45
    },
    {
        "pokedex_id": 887,
        "name": "Dragapult",
        "capture_rate": 45
    },
    {
        "pokedex_id": 132,
        "name": "Ditto",
        "capture_rate": 35
    },
    {
        "pokedex_id": 113,
        "name": "Chansey",
        "capture_rate": 30
    },
    {
        "pokedex_id": 198,
        "name": "Murkrow",
        "capture_rate": 30
    },
    {
        "pokedex_id": 242,
        "name": "Blissey",
        "capture_rate": 30
    },
    {
        "pokedex_id": 359,
        "name": "Absol",
        "capture_rate": 30
    },
    {
        "pokedex_id": 430,
        "name": "Honchkrow",
        "capture_rate": 30
    },
    {
        "pokedex_id": 441,
        "name": "Chatot",
        "capture_rate": 30
    },
    {
        "pokedex_id": 462,
        "name": "Magnezone",
        "capture_rate": 30
    },
    {
        "pokedex_id": 463,
        "name": "Lickilicky",
        "capture_rate": 30
    },
    {
        "pokedex_id": 464,
        "name": "Rhyperior",
        "capture_rate": 30
    },
    {
        "pokedex_id": 465,
        "name": "Tangrowth",
        "capture_rate": 30
    },
    {
        "pokedex_id": 466,
        "name": "Electivire",
        "capture_rate": 30
    },
    {
        "pokedex_id": 467,
        "name": "Magmortar",
        "capture_rate": 30
    },
    {
        "pokedex_id": 468,
        "name": "Togekiss",
        "capture_rate": 30
    },
    {
        "pokedex_id": 469,
        "name": "Yanmega",
        "capture_rate": 30
    },
    {
        "pokedex_id": 472,
        "name": "Gliscor",
        "capture_rate": 30
    },
    {
        "pokedex_id": 474,
        "name": "Porygon-Z",
        "capture_rate": 30
    },
    {
        "pokedex_id": 489,
        "name": "Phione",
        "capture_rate": 30
    },
    {
        "pokedex_id": 601,
        "name": "Klinklang",
        "capture_rate": 30
    },
    {
        "pokedex_id": 604,
        "name": "Eelektross",
        "capture_rate": 30
    },
    {
        "pokedex_id": 774,
        "name": "Minior",
        "capture_rate": 30
    },
    {
        "pokedex_id": 805,
        "name": "Stakataka",
        "capture_rate": 30
    },
    {
        "pokedex_id": 806,
        "name": "Blacephalon",
        "capture_rate": 30
    },
    {
        "pokedex_id": 864,
        "name": "Cursola",
        "capture_rate": 30
    },
    {
        "pokedex_id": 876,
        "name": "Indeedee",
        "capture_rate": 30
    },
    {
        "pokedex_id": 36,
        "name": "Clefable",
        "capture_rate": 25
    },
    {
        "pokedex_id": 143,
        "name": "Snorlax",
        "capture_rate": 25
    },
    {
        "pokedex_id": 208,
        "name": "Steelix",
        "capture_rate": 25
    },
    {
        "pokedex_id": 212,
        "name": "Scizor",
        "capture_rate": 25
    },
    {
        "pokedex_id": 226,
        "name": "Mantine",
        "capture_rate": 25
    },
    {
        "pokedex_id": 227,
        "name": "Skarmory",
        "capture_rate": 25
    },
    {
        "pokedex_id": 369,
        "name": "Relicanth",
        "capture_rate": 25
    },
    {
        "pokedex_id": 458,
        "name": "Mantyke",
        "capture_rate": 25
    },
    {
        "pokedex_id": 550,
        "name": "Basculin",
        "capture_rate": 25
    },
    {
        "pokedex_id": 615,
        "name": "Cryogonal",
        "capture_rate": 25
    },
    {
        "pokedex_id": 781,
        "name": "Dhelmise",
        "capture_rate": 25
    },
    {
        "pokedex_id": 637,
        "name": "Volcarona",
        "capture_rate": 15
    },
    {
        "pokedex_id": 888,
        "name": "Zacian",
        "capture_rate": 10
    },
    {
        "pokedex_id": 889,
        "name": "Zamazenta",
        "capture_rate": 10
    },
    {
        "pokedex_id": 144,
        "name": "Articuno",
        "capture_rate": 3
    },
    {
        "pokedex_id": 145,
        "name": "Zapdos",
        "capture_rate": 3
    },
    {
        "pokedex_id": 146,
        "name": "Moltres",
        "capture_rate": 3
    },
    {
        "pokedex_id": 150,
        "name": "Mewtwo",
        "capture_rate": 3
    },
    {
        "pokedex_id": 243,
        "name": "Raikou",
        "capture_rate": 3
    },
    {
        "pokedex_id": 244,
        "name": "Entei",
        "capture_rate": 3
    },
    {
        "pokedex_id": 245,
        "name": "Suicune",
        "capture_rate": 3
    },
    {
        "pokedex_id": 249,
        "name": "Lugia",
        "capture_rate": 3
    },
    {
        "pokedex_id": 250,
        "name": "Ho-Oh",
        "capture_rate": 3
    },
    {
        "pokedex_id": 374,
        "name": "Beldum",
        "capture_rate": 3
    },
    {
        "pokedex_id": 375,
        "name": "Metang",
        "capture_rate": 3
    },
    {
        "pokedex_id": 376,
        "name": "Metagross",
        "capture_rate": 3
    },
    {
        "pokedex_id": 377,
        "name": "Regirock",
        "capture_rate": 3
    },
    {
        "pokedex_id": 378,
        "name": "Regice",
        "capture_rate": 3
    },
    {
        "pokedex_id": 379,
        "name": "Registeel",
        "capture_rate": 3
    },
    {
        "pokedex_id": 380,
        "name": "Latias",
        "capture_rate": 3
    },
    {
        "pokedex_id": 381,
        "name": "Latios",
        "capture_rate": 3
    },
    {
        "pokedex_id": 382,
        "name": "Kyogre",
        "capture_rate": 3
    },
    {
        "pokedex_id": 383,
        "name": "Groudon",
        "capture_rate": 3
    },
    {
        "pokedex_id": 385,
        "name": "Jirachi",
        "capture_rate": 3
    },
    {
        "pokedex_id": 386,
        "name": "Deoxys",
        "capture_rate": 3
    },
    {
        "pokedex_id": 480,
        "name": "Uxie",
        "capture_rate": 3
    },
    {
        "pokedex_id": 481,
        "name": "Mesprit",
        "capture_rate": 3
    },
    {
        "pokedex_id": 482,
        "name": "Azelf",
        "capture_rate": 3
    },
    {
        "pokedex_id": 483,
        "name": "Dialga",
        "capture_rate": 3
    },
    {
        "pokedex_id": 484,
        "name": "Palkia",
        "capture_rate": 3
    },
    {
        "pokedex_id": 485,
        "name": "Heatran",
        "capture_rate": 3
    },
    {
        "pokedex_id": 486,
        "name": "Regigigas",
        "capture_rate": 3
    },
    {
        "pokedex_id": 487,
        "name": "Giratina",
        "capture_rate": 3
    },
    {
        "pokedex_id": 488,
        "name": "Cresselia",
        "capture_rate": 3
    },
    {
        "pokedex_id": 490,
        "name": "Manaphy",
        "capture_rate": 3
    },
    {
        "pokedex_id": 491,
        "name": "Darkrai",
        "capture_rate": 3
    },
    {
        "pokedex_id": 493,
        "name": "Arceus",
        "capture_rate": 3
    },
    {
        "pokedex_id": 494,
        "name": "Victini",
        "capture_rate": 3
    },
    {
        "pokedex_id": 638,
        "name": "Cobalion",
        "capture_rate": 3
    },
    {
        "pokedex_id": 639,
        "name": "Terrakion",
        "capture_rate": 3
    },
    {
        "pokedex_id": 640,
        "name": "Virizion",
        "capture_rate": 3
    },
    {
        "pokedex_id": 890,
        "name": "Eternatus",
        "capture_rate": 3
    },
    {
        "pokedex_id": 641,
        "name": "Tornadus",
        "capture_rate": 3
    },
    {
        "pokedex_id": 642,
        "name": "Thundurus",
        "capture_rate": 3
    },
    {
        "pokedex_id": 643,
        "name": "Reshiram",
        "capture_rate": 3
    },
    {
        "pokedex_id": 644,
        "name": "Zekrom",
        "capture_rate": 3
    },
    {
        "pokedex_id": 645,
        "name": "Landorus",
        "capture_rate": 3
    },
    {
        "pokedex_id": 646,
        "name": "Kyurem",
        "capture_rate": 3
    },
    {
        "pokedex_id": 647,
        "name": "Keldeo",
        "capture_rate": 3
    },
    {
        "pokedex_id": 648,
        "name": "Meloetta",
        "capture_rate": 3
    },
    {
        "pokedex_id": 649,
        "name": "Genesect",
        "capture_rate": 3
    },
    {
        "pokedex_id": 718,
        "name": "Zygarde",
        "capture_rate": 3
    },
    {
        "pokedex_id": 719,
        "name": "Diancie",
        "capture_rate": 3
    },
    {
        "pokedex_id": 720,
        "name": "Hoopa",
        "capture_rate": 3
    },
    {
        "pokedex_id": 721,
        "name": "Volcanion",
        "capture_rate": 3
    },
    {
        "pokedex_id": 772,
        "name": "Type: Null",
        "capture_rate": 3
    },
    {
        "pokedex_id": 773,
        "name": "Silvally",
        "capture_rate": 3
    },
    {
        "pokedex_id": 785,
        "name": "Tapu Koko",
        "capture_rate": 3
    },
    {
        "pokedex_id": 786,
        "name": "Tapu Lele",
        "capture_rate": 3
    },
    {
        "pokedex_id": 787,
        "name": "Tapu Bulu",
        "capture_rate": 3
    },
    {
        "pokedex_id": 788,
        "name": "Tapu Fini",
        "capture_rate": 3
    },
    {
        "pokedex_id": 801,
        "name": "Magearna",
        "capture_rate": 3
    },
    {
        "pokedex_id": 802,
        "name": "Marshadow",
        "capture_rate": 3
    },
    {
        "pokedex_id": 807,
        "name": "Zeraora",
        "capture_rate": 3
    },
    {
        "pokedex_id": 808,
        "name": "Meltan",
        "capture_rate": 3
    },
    {
        "pokedex_id": 809,
        "name": "Melmetal",
        "capture_rate": 3
    },
    {
        "pokedex_id": 891,
        "name": "Kubfu",
        "capture_rate": 3
    },
    {
        "pokedex_id": 892,
        "name": "Urshifu",
        "capture_rate": 3
    },
    {
        "pokedex_id": 893,
        "name": "Zarude",
        "capture_rate": 3
    },
    {
        "pokedex_id": 894,
        "name": "Regieleki",
        "capture_rate": 3
    },
    {
        "pokedex_id": 895,
        "name": "Regidrago",
        "capture_rate": 3
    },
    {
        "pokedex_id": 896,
        "name": "Glastrier",
        "capture_rate": 3
    },
    {
        "pokedex_id": 897,
        "name": "Spectrier",
        "capture_rate": 3
    },
    {
        "pokedex_id": 898,
        "name": "Calyrex",
        "capture_rate": 3
    }
]